namespace AgerLMS {
    export namespace PermissionKeys {
        export const StudyTracking = "Coaching:StudyTracking:";
        export const StudyTrackingRead = "Coaching:StudyTracking:Read";
        export const StudyTrackingModify = "Coaching:StudyTracking:Modify";
        export const StudyTrackingPage = "Coaching:StudyTracking:StudyTrackingPage";
        export const MyStudyTrackingPage = "Coaching:StudyTracking:MyStudyTrackingPage";
        export const ExamDate = "Coaching:ExamDate:";
        export const ExamDateRead = "Coaching:ExamDate:Read";
        export const ExamDateModify = "Coaching:ExamDate:Modify";
        export const ExamDatePage = "Coaching:ExamDate:ExamDatePage";
        export const ExamLesson = "Coaching:ExamLesson:";
        export const ExamLessonRead = "Coaching:ExamLesson:Read";
        export const ExamLessonModify = "Coaching:ExamLesson:Modify";
        export const ExamLessonPage = "Coaching:ExamLesson:ExamLessonPage";
        export const PointsCalculation = "Coaching:PointsCalculation:";
        export const PointsCalculationRead = "Coaching:PointsCalculation:Read";
        export const PointsCalculationModify = "Coaching:PointsCalculation:Modify";
        export const PointsCalculationPage = "Coaching:PointsCalculation:PointsCalculationPage";
        export const UserCurrentState = "Coaching:UserCurrentState:";
        export const UserCurrentStateRead = "Coaching:UserCurrentState:Read";
        export const UserCurrentStateModify = "Coaching:UserCurrentState:Modify";
        export const UserCurrentStatePage = "Coaching:UserCurrentState:UserCurrentStatePage";
        export const UserDailyWorkTime = "Coaching:UserDailyWorkTime:";
        export const UserDailyWorkTimeRead = "Coaching:UserDailyWorkTime:Read";
        export const UserDailyWorkTimeModify = "Coaching:UserDailyWorkTime:Modify";
        export const UserDailyWorkTimePage = "Coaching:UserDailyWorkTime:UserDailyWorkTimePage";
        export const ZoomPage = "LMS:Zoom:Page";
        export const GENERAL = "General:";
        export const GeneralPanel = "General:Panel";
        export const GeneralStudentPanel = "General:StudentPanel";
        export const GeneralInstructorPanel = "General:InstructorPanel";
        export const Lms = "LMS";
        export const SiteSetting = "LMS:SiteSetting:";
        export const SiteSettingRead = "LMS:SiteSetting:Read";
        export const SiteSettingModify = "LMS:SiteSetting:Modify";
        export const SiteSettingPage = "LMS:SiteSetting:Page";
        export const Course = "LMS:Course:";
        export const CourseRead = "LMS:Course:Read";
        export const CourseModify = "LMS:Course:Modify";
        export const NewCoursePage = "LMS:Course:NewCoursePage";
        export const CoursesPage = "LMS:Course:CoursesPage";
        export const Bundle = "LMS:Bundle:";
        export const BundleRead = "LMS:Bundle:Read";
        export const BundleModify = "LMS:Bundle:Modify";
        export const NewBundlePage = "LMS:Bundle:NewBundlePage";
        export const BundlesPage = "LMS:Bundle:BundlesPage";
        export const Product = "LMS:Product:";
        export const ProductRead = "LMS:Product:Read";
        export const ProductModify = "LMS:Product:Modify";
        export const NewProductPage = "LMS:Product:NewProductPage";
        export const ProductsPage = "LMS:Product:ProductsPage";
        export const Quiz = "LMS:Quiz:";
        export const QuizRead = "LMS:Quiz:Read";
        export const QuizModify = "LMS:Quiz:Modify";
        export const QuizzesPage = "LMS:Quiz:Page";
        export const QuizStartPage = "LMS:Quiz:QuizStartPage";
        export const QuizResultPage = "LMS:Quiz:QuizResultPage";
        export const MyQuizResultsPage = "LMS:Quiz:MyQuizResultsPage";
        export const MyQuizzesPage = "LMS:Quiz:MyQuizzesPage";
        export const LmsCategory = "LMS:LmsCategory:";
        export const LmsCategoryRead = "LMS:LmsCategory:Read";
        export const LmsCategoryModify = "LMS:LmsCategory:Modify";
        export const LmsCategoriesPage = "LMS:LmsCategory:Page";
        export const Discount = "LMS:Discount:";
        export const DiscountRead = "LMS:Discount:Read";
        export const DiscountModify = "LMS:Discount:Modify";
        export const DiscountsPage = "LMS:Discount:Page";
        export const MyDiscountsPage = "LMS:Discount:MyDiscountsPage";
        export const Badge = "LMS:Badge:";
        export const BadgeRead = "LMS:Badge:Read";
        export const BadgeModify = "LMS:Badge:Modify";
        export const BadgesPage = "LMS:Badge:Page";
        export const Order = "LMS:Order:";
        export const OrderRead = "LMS:Order:Read";
        export const OrderModify = "LMS:Order:Modify";
        export const OrderPage = "LMS:Order:OrderPage";
        export const OrderConfirmPaymentPage = "LMS:Order:OrderConfirmPaymentPage";
        export const UnpaidOrdersPage = "LMS:Order:UnpaidOrdersPage";
        export const DiscountOrdersPage = "LMS:Order:DiscountOrdersPage";
        export const OrderItem = "LMS:OrderItem:";
        export const OrderItemRead = "LMS:OrderItem:Read";
        export const OrderItemInsert = "LMS:OrderItem:Insert";
        export const OrderItemUpdate = "LMS:OrderItem:Update";
        export const OrderItemDelete = "LMS:OrderItem:Delete";
        export const PurchasedWebinarsPage = "LMS:OrderItem:PurchasedWebinarsPage";
        export const PurchasedProductsPage = "LMS:OrderItem:PurchasedProductsPage";
        export const LMSComment = "LMS:LMSComment:";
        export const LMSCommentRead = "LMS:LMSComment:Read";
        export const LMSCommentModify = "LMS:LMSComment:Modify";
        export const LmsCommentPage = "LMS:LMSComment:LmsCommentPage";
        export const MyWebinarCommentsPage = "LMS:LMSComment:MyWebinarCommentsPage";
        export const MyProductCommentsPage = "LMS:LMSComment:MyProductCommentsPage";
        export const Faq = "LMS:Faq:";
        export const FaqRead = "LMS:Faq:Read";
        export const FaqModify = "LMS:Faq:Modify";
        export const FaqPage = "LMS:Faq:FaqPage";
        export const FaqSitePage = "LMS:Faq:FaqSitePage";
        export const CmsPage = "LMS:CmsPage:";
        export const LMSCmsPageRead = "LMS:CmsPage:Read";
        export const LMSCmsPageModify = "LMS:CmsPage:Modify";
        export const LmsCmsPagePage = "LMS:CmsPage:CmsPagePage";
        export const Slider = "CMS:Slider:";
        export const SliderRead = "CMS:Slider:Read";
        export const SliderModify = "LMS:CmsPage:Modify";
        export const SliderPage = "CMS:Slider:SliderPage";
        export const KeyValueSetting = "CMS:KeyValueSetting:";
        export const KeyValueSettingRead = "CMS:KeyValueSetting:Read";
        export const KeyValueSettingModify = "LMS:CmsPage:Modify";
        export const KeyValueSettingPage = "CMS:KeyValueSetting:KeyValueSettingPage";
        export const QuizQuestion = "LMS:QuizQuestion:";
        export const QuizQuestionRead = "LMS:QuizQuestion:Read";
        export const QuizQuestionModify = "LMS:QuizQuestion:Modify";
        export const QuizQuestionPage = "LMS:QuizQuestion:QuizQuestionPage";
        export const Cargo = "LMS:Cargo:";
        export const CargoRead = "LMS:Cargo:Read";
        export const CargoModify = "LMS:Cargo:Modify";
        export const CargoPage = "LMS:Cargo:CargoPage";
        export const LiveBroadcast = "LMS:LiveBroadcast:";
        export const LiveBroadcastRead = "LMS:LiveBroadcast:Read";
        export const LiveBroadcastModify = "LMS:LiveBroadcast:Modify";
        export const LiveBroadcastPage = "LMS:LiveBroadcast:LiveBroadcastPage";
        export const LiveBroadcastUser = "LMS:LiveBroadcastUser:";
        export const LiveBroadcastUserRead = "LMS:LiveBroadcastUser:Read";
        export const LiveBroadcastUserModify = "LMS:LiveBroadcastUser:Modify";
        export const Logging = "Logging";
        export const SmsSendLog = "Logging:SmsSendLog:";
        export const SmsSendLogRead = "Logging:SmsSendLog:Read";
        export const SmsSendLogModify = "Logging:SmsSendLog:Modify";
        export const SmsSendLogPage = "Logging:SmsSendLog:Page";
        export const ManuelSmsSendPage = "Logging:ManuelSmsSend:Page";
        export const UserEventLog = "Logging:UserEventLog:";
        export const UserEventLogRead = "Logging:UserEventLog:Read";
        export const UserEventLogModify = "Logging:UserEventLog:Modify";
        export const UserEventLogPage = "Logging:UserEventLog:Page";
        export const LessonWatchLog = "Logging:LessonWatchLog:";
        export const LessonWatchLogRead = "Logging:LessonWatchLog:Read";
        export const LessonWatchLogInsert = "Logging:LessonWatchLog:Insert";
        export const LessonWatchLogUpdate = "Logging:LessonWatchLog:Update";
        export const LessonWatchLogDelete = "Logging:LessonWatchLog:Delete";
        export const LessonWatchLogPage = "Logging:LessonWatchLog:Page";
        export const LessonWatchLogBackup = "Logging:LessonWatchLogBackup:";
        export const LessonWatchLogBackupRead = "Logging:LessonWatchLogBackup:Read";
        export const LessonWatchLogBackupInsert = "Logging:LessonWatchLogBackup:Insert";
        export const LessonWatchLogBackupUpdate = "Logging:LessonWatchLogBackup:Update";
        export const LessonWatchLogBackupDelete = "Logging:LessonWatchLogBackup:Delete";
        export const LessonWatchLogBackupPage = "Logging:LessonWatchLogBackup:Page";
        export const UserQuizAnswer = "Logging:UserQuizAnswer:";
        export const UserQuizAnswerRead = "Logging:UserQuizAnswer:Read";
        export const UserQuizAnswerModify = "Logging:UserEventLog:Modify";
        export const UserQuizAnswerPage = "Logging:UserQuizAnswer:Page";
        export const LmsNotificationLog = "Logging:LmsNotification:";
        export const LmsNotificationRead = "Logging:LmsNotification:Read";
        export const LmsNotificationInsert = "Logging:LmsNotification:Insert";
        export const LmsNotificationUpdate = "Logging:LmsNotification:Update";
        export const LmsNotificationDelete = "Logging:LmsNotification:Delete";
        export const MyNotificationsPage = "Logging:LmsNotification:MyNotifications";
        export const LmsNotificationPage = "Logging:LmsNotification:Page";
        export const UserActivity = "Logging:UserActivity:";
        export const UserActivityRead = "Logging:UserActivity:Read";
        export const UserActivityPage = "Logging:UserActivity:Page";
        export const ContactMessage = "Logging:ContactMessage:";
        export const ContactMessageRead = "Logging:ContactMessage:Read";
        export const ContactMessagePage = "Logging:ContactMessage:Page";
        export const PaymentResponseLog = "Logging:PaymentResponseLog:";
        export const PaymentResponseLogRead = "Logging:PaymentResponseLog:Read";
        export const PaymentResponseLogPage = "Logging:PaymentResponseLog:Page";
        export const ServerVideoPage = "Logging:ServerVideo:Page";
        export const UserVideoFileRead = "Logging:UserVideoFile:Read";
        export const UserVideoFileModify = "Logging:UserVideoFile:Modify";
        export const UserVideoFilePage = "Logging:UserVideoFile:Page";
        export const Newsletter = "Logging:Newsletter:";
        export const NewsletterPage = "Logging:Newsletter:Page";
    }
}
